import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';

import { CompanyBranchDropdown } from '../components/dropdowns/single/CompanyBranch';
import { ListSettingsNaviList } from '../components/list/ListSettingsNaviList';
import { PreviewTableItem } from '../components/ListSettingDndTableItem';

import { CompanyBranchService } from '../services/CompanyBranches';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

import masterSlideLoader from '../utilities/masterSlideLoader';

import {
  HEADER_CONSTANTS, // ヘッダータイトル
  USER_ROLES,
} from '../utilities/constants';
import { isTargetRoleId } from '../utilities/roleUtility';
import { MasterPageHeader } from '../components/PageHeader';
import { Description } from '../components/Description';

/**
 * 会社情報確認 画面
 *  元請用
 * 画面遷移
 *  - 本社管理者でログイン > 会社情報確認 > 編集ボタン
 */
export class ListSettingsPreview extends React.Component {
  constructor(props) {
    super(props);

    this.companyBranchId = parseInt(
      SessionStorageService.getItem('company_branch_id'),
      10
    ); // 支店ID

    const roleId = LocalStorageService.getRoleId();
    const isPrimeUser = isTargetRoleId([USER_ROLES.prime], roleId);

    this.state = {
      companyBranch: {},
      isPrimeUser,
      branchLoaded: false,
      partnerCompanyId: '', // 協力会社ID
      showConfirmDialog: false,
      showGoBackDialog: false,

      values: {
        company_branch_id: null, // 会社名
      },

      listItems: [],
      work_columns_settings: {
        conference_order: [],
        list_order: [],
      },
    };

    this.submitRef = React.createRef(); // 登録ボタン要素

    // イベント登録
    this.events = {
      close: this.close.bind(this), // 閉じる
      setDropdownData: this.setDropdownData.bind(this),
    };
  }

  componentDidMount() {
    let companyBranchId;
    if (_.parseInt(this.props.view.state.id) !== 0) {
      companyBranchId = _.parseInt(this.props.view.state.id);
    } else {
      companyBranchId = _.parseInt(this.companyBranchId);
    }
    this.setState(
      {
        values: {
          company_branch_id: companyBranchId,
        },
      },
      () => {
        this.getBranchInfo(companyBranchId);
        this.getWorkColumnsSettings(companyBranchId);
      }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !_.isEqual(
        prevState.values.company_branch_id,
        this.state.values.company_branch_id
      )
    ) {
      this.getBranchInfo(this.state.values.company_branch_id);
      this.getWorkColumnsSettings(this.state.values.company_branch_id);
    }
  }

  getBranchInfo = id => {
    CompanyBranchService.showBranch(id).then(response => {
      if (response.result === false) {
        return;
      } else {
        const data = response.data.entities.company_branch;
        this.setState({
          branchLoaded: true,
          companyBranch: data,
        });
      }
    });
  };

  getWorkColumnsSettings = (id, param) => {
    CompanyBranchService.workColumnsSettings(id, param).then(response => {
      if (
        response.result === false ||
        !_.has(response, 'data.entities.work_columns_settings')
      ) {
        return;
      } else {
        const data = response.data.entities.work_columns_settings;
        const editableList = _.map(
          _.sortBy(
            _.filter(data.list_order, item => {
              return item.editable;
            }),
            'order_number'
          ),
          listItem => {
            return {
              name: listItem.name,
              type: listItem.type,
              list_display: listItem.display,
            };
          }
        );

        const finishedList = _.map(editableList, listItem => {
          const conferenceItem = _.find(data.conference_order, conf_item => {
            return conf_item.type === listItem.type;
          });
          const multipleEditItem = _.find(
            data.edit_multiple_order,
            conf_item => {
              return conf_item.type === listItem.type;
            }
          );
          return {
            name: listItem.name,
            type: listItem.type,
            list_display: listItem.list_display,
            conference_display: conferenceItem.display,
            multiple_edit_display: multipleEditItem.display,
          };
        });
        this.setState({
          listItems: finishedList,
          work_columns_settings: response.data.entities.work_columns_settings,
        });
      }
    });
  };

  // 戻るダイアログ
  close = () => {
    masterSlideLoader.close();
  };

  setDropdownData = (name, value) => {
    this.setState({
      values: {
        ...this.state.values,
        [name]: value,
      },
    });
  };

  render() {
    const { isPrimeUser, branchLoaded, companyBranch } = this.state;
    return (
      <React.Fragment>
        <div id='slide-view' className='contruction-slide-view show'>
          <Helmet>
            <title>{HEADER_CONSTANTS.title} - 一覧表示設定</title>
          </Helmet>
          <div className='contruction-slide-view__view'>
            <MasterPageHeader
              title={'一覧表示設定'}
              onClose={() => this.events.close()}
            />
            <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
              <div className='contruction-detail-view'>
                <div className='contruction-detail-view__sidemenu'>
                  <ListSettingsNaviList />
                </div>
                <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                  <div className='contruction-detail-view__menu list-settings-menu'>
                    {branchLoaded ? (
                      <React.Fragment>
                        <span className='construction-detail-view__button'>
                          <button
                            className='btn'
                            onClick={() => {
                              masterSlideLoader.show('ListSettingsEdit', {
                                state: {
                                  id: this.state.companyBranch.id,
                                },
                              });
                            }}
                          >
                            編集
                          </button>
                        </span>
                        {isPrimeUser ? (
                          <div className='list-settings-dropdown set-width-dropdown'>
                            <CompanyBranchDropdown
                              my_branch={companyBranch.id}
                              my_branch_name={companyBranch.name}
                              name='company_branch_id'
                              value={this.state.values.company_branch_id}
                              set={(e, s) => this.events.setDropdownData(e, s)}
                              setkey='company_branch_id'
                            />
                            <div className='list-settings-dropdown__info'>
                              <span className='list-settings-dropdown__text'>
                                支店を選択
                              </span>
                              <span className='list-settings-dropdown__text list-settings-dropdown__text--small'>
                                ※支店ごとに情報が違います
                              </span>
                            </div>
                          </div>
                        ) : (
                          <span>支店：{companyBranch.name}</span>
                        )}
                      </React.Fragment>
                    ) : (
                      <ClipLoader size={20} color={'#EDB715'} />
                    )}
                  </div>
                  <div className='contruction-detail-view__bar' />
                  <div className='contruction-detail-view__main contruction-detail-view__main--fixed list-settings'>
                    <div className='list-settings-message'>
                      <Description>
                        <p>
                          作業予定一覧・作業実績一覧で表示する項目、および一括編集を許可する項目の選択と並べ替えが設定できます。
                        </p>
                        <p>
                          設定は支店単位になります。支店内の全現場に即時反映されますのでご注意ください。
                        </p>
                        <p>
                          なお、現場ごとの項目設定で設定した内容はこのページの設定より優先されます。
                        </p>
                      </Description>
                    </div>
                    <div className='list-settings-table'>
                      <div className='list-settings-table__header'>
                        <div className='list-settings-table-cell list-settings-table-item__icon' />
                        <div className='list-settings-table-cell list-settings-table-item__name'>
                          項目名
                        </div>
                        <div className='list-settings-table-cell list-settings-table-item__list-display'>
                          通常モード表示
                        </div>
                        <div className='list-settings-table-cell list-settings-table-item__conference-display'>
                          会議モード表示
                        </div>
                        <div className='list-settings-table-cell list-settings-table-item__multiple-edit-display'>
                          一括編集を許可
                        </div>
                      </div>
                      <ul>
                        {this.state.listItems.map((item, i) => (
                          <PreviewTableItem
                            key={i}
                            name={item.name}
                            conferenceDisplay={item.conference_display}
                            listDisplay={item.list_display}
                            multipleEditDisplay={item.multiple_edit_display}
                          />
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ListSettingsPreview.jsx